import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var EmptyState = function EmptyState(_ref) {
  var title = _ref.title,
    description = _ref.description,
    icon = _ref.icon,
    image = _ref.image,
    primaryAction = _ref.primaryAction,
    secondaryContent = _ref.secondaryContent,
    highlightedText = _ref.highlightedText,
    className = _ref.className,
    small = _ref.small,
    style = _ref.style;
  return /*#__PURE__*/_jsxs(EmptyStateContainer, {
    className: className,
    style: style,
    children: [icon && /*#__PURE__*/_jsx(EmptyStateIcon, {
      small: small,
      children: icon
    }), image && /*#__PURE__*/_jsx("img", {
      width: 190,
      height: 152,
      src: image.src,
      alt: image.alt || 'empty illustration',
      className: "tw-mb-1.6"
    }), /*#__PURE__*/_jsxs(EmptyStateTitle, {
      small: small,
      children: [title, highlightedText && /*#__PURE__*/_jsx("span", {
        className: "tw-text-primary-light-500",
        children: highlightedText
      })]
    }), /*#__PURE__*/_jsx(EmptyStateDescription, {
      small: small,
      children: description
    }), primaryAction && /*#__PURE__*/_jsx("div", {
      className: "tw-mb-1.6",
      children: primaryAction
    }), secondaryContent]
  });
};
export var EmptyStateContainer = function EmptyStateContainer(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    style = _ref2.style;
  return /*#__PURE__*/_jsx("section", {
    className: cn('tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-3.2 sm:tw-p-[10rem]', className),
    style: style,
    children: children
  });
};
export var EmptyStateIcon = function EmptyStateIcon(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    style = _ref3.style,
    small = _ref3.small;
  return /*#__PURE__*/_jsx("div", {
    className: cn(' tw-bg-neutral-light-300 tw-rounded-full tw-flex tw-justify-center tw-items-center', !small && 'tw-size-6 tw-mt-4 tw-mb-1', small && 'tw-size-4 tw-m-0', className),
    style: style,
    children: children
  });
};
export var EmptyStateTitle = function EmptyStateTitle(_ref4) {
  var children = _ref4.children,
    small = _ref4.small,
    className = _ref4.className;
  return /*#__PURE__*/_jsx("span", {
    className: cn('tw-text-center tw-block tw-mb-0.8', small && 'tw-font-subtitle5 tw-mt-0.8', !small && 'tw-font-subtitle4 tw-mt-2', className),
    children: children
  });
};
export var EmptyStateDescription = function EmptyStateDescription(_ref5) {
  var children = _ref5.children,
    small = _ref5.small,
    className = _ref5.className;
  return /*#__PURE__*/_jsx("span", {
    className: cn('tw-font-body5 tw-text-center tw-block tw-text-neutral-light-700', small && 'tw-mb-0.8', !small && 'tw-mb-1.6', className),
    children: children
  });
};